import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/location-icon.png'


const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "flex flex-col items-cent space-y-4 md:flex-row md:space-x-9 md:space-y-0" }
const _hoisted_3 = { class: "flex space-x-2 items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-8"
}, null, -1)
const _hoisted_5 = { class: "text-lg text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.locationInfo.place_name), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Form, { onSubmit: _ctx.fetchWeather }, {
          default: _withCtx(() => [
            _createVNode(_component_Field, {
              name: "location",
              type: "text",
              class: "border bg-gray-200 px-4 py-2 w-full rounded-md placeholder:text-gray-700",
              placeholder: "Search city...",
              modelValue: _ctx.locationInfo.city,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.locationInfo.city) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ])
  ]))
}